module.exports = __webpack_public_path__ + "92727eeec28afb7b59c60b5ea4e2ca25.jpg";